import { getBaseConfig, getConfig, getContext, setBaseConfig, setConfig, setContext, setDeviceData, getDeviceData, getSardineHost, } from './data-holder';
const setupSardine = (params) => {
    setBaseConfig(params);
};
const updateSardineConfig = async (params) => {
    return new Promise(function (resolve, reject) {
        const { clientId, environment, region, apiSubdomain, pixelSubdomain } = getBaseConfig();
        if (!clientId) {
            reject({
                status: 'error',
                error: new Error('clientId is required'),
            });
            return;
        }
        const sardineContext = getContext();
        const { customerId, sessionKey, flow, fields, enableBiometrics, enableGeoLocation, enablePortScanning, parentSessionKey, partnerId, } = params;
        if (sardineContext &&
            !enableBiometrics &&
            !enableGeoLocation &&
            !enablePortScanning &&
            !parentSessionKey &&
            !partnerId) {
            sardineContext.updateConfig({ flow, userIdHash: customerId, sessionKey, fields });
            setConfig(params);
            resolve({ status: 'success' });
        }
        else {
            const isSandbox = environment === 'sandbox';
            var sardineHost = getSardineHost();
            const domain = apiSubdomain || sardineHost;
            var loader = document.createElement('script');
            loader.type = 'text/javascript';
            loader.async = true;
            loader.src = `https://${domain}/assets/loader.min.js`;
            loader.onload = function async() {
                const sardineContext = window._Sardine.createContext({
                    clientId,
                    sessionKey,
                    userIdHash: customerId,
                    flow: flow || location.pathname,
                    environment: isSandbox ? 'sandbox' : 'production',
                    parentElement: document.body,
                    partnerId,
                    parentSessionKey,
                    enablePortScanning,
                    enableBiometrics: enableBiometrics || true,
                    enableGeoLocation,
                    apiSubdomain,
                    pixelSubdomain,
                    fields,
                    // called when sardine generates/restores deviceID for given device.
                    onDeviceResponse: function async(data) {
                        setDeviceData(data);
                        resolve({ status: 'success' });
                    },
                });
                setConfig(params);
                setContext(sardineContext);
            };
            var s = document.getElementsByTagName('script')[0];
            s.parentNode?.insertBefore(loader, s);
        }
    });
};
const getSardineConfig = () => {
    return getConfig();
};
const getDeviceResponse = () => {
    return getDeviceData();
};
const unbind = () => {
    const sardineContext = getContext();
    if (sardineContext) {
        sardineContext.unbind();
        return true;
    }
    return false;
};
export { setupSardine, updateSardineConfig, getSardineConfig, getDeviceResponse, unbind };
